<template>
  <custom-select
    :list="itemsList"
    :data="data"
    :search-is-loading="isLoading"
    label="Разрешения и доступы"
    search-label="Поиск разрешений"
    search
    chips
    multiple
    @change="onChange"
    @search="debouncedFetch"
  />
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import CustomSelect from '@/components/ui/custom-select';

export default {
  name: 'permissions-select',
  components: {
    CustomSelect,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    itemsList: {
      type: Array,
      required: true,
    },
    value: [Object, Array],
    data: [Object, Array],
  },
  data: () => ({
    isLoading: false,
  }),
  created() {
    const debouncedFetch = debounce(this.onSearch, 300);

    this.debouncedFetch = (...args) => {
      this.isLoading = true;
      debouncedFetch(...args);
    };
  },
  methods: {
    ...mapActions('permissions/searchSelect', ['getList']),

    async onSearch(query) {
      if (!query || query.length < 3) {
        await this.getList();
        this.isLoading = false;
        return;
      }

      this.lastQuery = query;

      try {
        await this.getList({ query });
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }

      if (this.lastQuery !== query) {
        this.onSearch(this.lastQuery);
      }
    },

    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
